import Stopwatch from './stopwatch';

// init new stopwatch

const sw = new Stopwatch();
sw.init();
